import Vue from "vue";
import { NotificationData} from "@/types";
import {MutationTree} from "vuex";
import { NotificationsAdminzoneState } from "@/types/store/adminzone/notification";

export const mutations: MutationTree<NotificationsAdminzoneState> = {
  SET_NOTIFICATIONS: (state, payload: Array<NotificationData>): Array<NotificationData> => Vue.set(state, "notifications", payload),

}
